import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, withCtx as _withCtx, KeepAlive as _KeepAlive, Transition as _Transition } from "vue";
import { App } from '@capacitor/app';
import { useTitle } from '@vueuse/core';
import { computed, onMounted } from 'vue';
import appConfig from '@/app-config';
import Router from '@/router';
import SkeletonPage from '@/skeletons/SkeletonPage.vue';
import TheShell from '@/components/TheShell.vue';
import useCall from '@/composables/global/use-call';
import useInitLoader from '@/composables/global/use-init-loader';
import useLogs from '@/composables/global/use-logs';
import { IonicBreakpointSmPx, IonicBreakpointMdPx, IonicBreakpointLgPx, IonicBreakpointXLPx } from '@/composables/global/use-responsiveness';
import useShellHeader from '@/composables/global/use-shell-header';
import { errorAlert } from '@/utils/ion-alert';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    _useCssVars(_ctx => ({
      "73d5f94d": _unref(IonicBreakpointSmPx),
      "73d31d4a": _unref(IonicBreakpointMdPx),
      "73d2b42e": _unref(IonicBreakpointLgPx),
      "73d7c347": _unref(IonicBreakpointXLPx)
    }));
    const {
      hasOngoingCallInChat
    } = useCall();
    const {
      appDataInitialized
    } = useInitLoader();
    const {
      addLog
    } = useLogs();
    const keepAliveComponentList = computed(() => {
      const keepAliveComponentList = ['UserList'];
      if (hasOngoingCallInChat.value) keepAliveComponentList.push('CallPage');
      return keepAliveComponentList;
    });
    const viewingUngaurdedRoute = computed(() => {
      return Router.currentRoute.value.matched.every(record => !record.meta.requiresAuth);
    });
    const {
      appTitle
    } = useShellHeader();
    const headTitle = computed(() => {
      const subTitle = appTitle.value ? ` | ${appTitle.value}` : '';
      return `${appConfig.capacitor.appName}${subTitle}`;
    });
    useTitle(headTitle);
    function interceptInternalAnchorClicks(event) {
      var _event$preventDefault;
      const target = event.target;
      const href = target.getAttribute('href');
      const isInternalLink = href !== null && href.includes(window.location.host);
      if (target.tagName !== 'A' || !isInternalLink) return;
      const {
        altKey,
        ctrlKey,
        metaKey,
        shiftKey,
        defaultPrevented
      } = event;
      // Don't handle when modifier key is used
      if (metaKey || altKey || ctrlKey || shiftKey) return;
      // Don't handle when preventDefault called
      if (defaultPrevented) return;
      const {
        pathname
      } = new URL(href);
      (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
      Router.push(pathname).catch(error => errorAlert({
        error
      }));
    }
    onMounted(async () => {
      await appDataInitialized();
      // Handle links to internal pages with router
      window.addEventListener('click', interceptInternalAnchorClicks);
      // Log app state changes
      App.addListener('appStateChange', appState => addLog({
        isActive: appState.isActive
      }));
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_ion_content = _resolveComponent("ion-content");
      return viewingUngaurdedRoute.value ? (_openBlock(), _createBlock(_component_router_view, {
        key: 0
      })) : (_openBlock(), _createBlock(TheShell, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component,
            route
          }) => [_createVNode(_Transition, {
            name: "view-fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
              include: keepAliveComponentList.value
            }, [Component ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: route.path
            })) : (_openBlock(), _createBlock(_component_ion_content, {
              key: 1
            }, {
              default: _withCtx(() => [_createVNode(SkeletonPage)]),
              _: 1
            }))], 1032, ["include"]))]),
            _: 2
          }, 1024)]),
          _: 1
        })]),
        _: 1
      }));
    };
  }
});